import { useParams } from 'react-router';

import InternalErrorState from '@/features/app/InternalErrorState';
import { useGetTyreReadingsQuery } from '@/services/api';
import TyreDetail, { TyreDetailSkeleton } from './TyreDetail';

const TyreDetailRoute = () => {
    const { assetId, position, side } = useParams<{
        assetId: string;
        position: string;
        side: string;
    }>();

    const { data, isLoading, error, refetch } = useGetTyreReadingsQuery(
        {
            assetId: assetId ?? '',
            axlePosition: position,
            axleSide: side,
        },
        { skip: !assetId },
    );

    if (isLoading) {
        return (
            <div className="padding-15 display-flex flex-column gap-10">
                <TyreDetailSkeleton />
            </div>
        );
    }
    if (error || !data || data.tyres.length === 0) {
        return <InternalErrorState reloadTriggerFunction={refetch} />;
    }

    const tyre = data.tyres[0];
    return (
        <div className="padding-15 display-flex flex-column gap-10">
            <TyreDetail tyre={tyre} />
        </div>
    );
};

export default TyreDetailRoute;
